export default __webpack_public_path__ + "static/media/telephone.fb244201.png";